export default "__VITE_ASSET__buWOQ7uW__"